/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 3/31/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {FormattedHTMLMessage, injectIntl} from 'react-intl';
import * as AssetActions from './AssetActions'
import * as SecurityActions from '../security/SecurityActions'
import {Button, Grid} from "@scuf/common";
import Loader from '../common/Loader'
import BreadCrumb from "../common/Bradcrumb";
import {getBreadcrumbItemsAsset, verifyAirtimeException} from "../utils/Helpers";
import {formatDateTime} from "../common/LocaleHelper";
import FaultsList from '../faults/list/FaultsList'
import {userHasActivity} from "../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../security/SecurityConst";
import {Routes} from "../utils/Routes";
import ExpandableCard from '../common/ExpandableCard'
import AssetChart from "../common/AssetChart"
import ErrorTitle from "../common/ErrorTitle"
import engineHTF7K from '../styling/images/AS907.png'
import engineTFE731 from '../styling/images/TFE731.png'

class Asset extends React.Component {

    componentDidMount() {
        const { match: { params } } = this.props;

        this.props.AssetActions.clearAsset()
        this.props.AssetActions.fetchAsset(params.assetId, userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params && prevProps.match.params.assetId !== this.props.match.params.assetId) {
            this.props.AssetActions.clearAsset()
            this.props.AssetActions.fetchAsset(this.props.match.params.assetId, userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)).catch(ex => {
                verifyForgeException(ex.errorKey, this.props.SecurityActions.signOut)
            })
        }
    }

    getAttributesComponents(attrs) {
        //first 4 attributes in two column format
        const mainAttrsRow = this.getAttrsColumnsInRow(attrs.slice(0, 4))
        //rest of attributes in two column format
        const moreAttrsRow = this.getAttrsColumnsInRow(attrs.slice(4, attrs.length))
        return <ExpandableCard
            expandable={attrs.length > 4}
            content={<Grid>{mainAttrsRow}</Grid>}
            expandedContent={<Grid>{moreAttrsRow}</Grid>}
            interactive={false}
            className='attributes-card'
        />
    }

    getAttrsColumnsInRow(attrs) {
        const column1attrs = [<div key='1'></div>]
        attrs.forEach((a) => {
            const attrCmp = this.getAttributesRow(a);
            column1attrs.push(attrCmp)
        })
        return <Grid.Row><Grid.Column width={12}>{column1attrs}</Grid.Column></Grid.Row>
    }

    getAttributesRow(a) {
        let value;
        switch(a.dataType) {
            case 'integer':
                value = a.valueInteger
                break;
            case 'decimal':
                value = a.valueDecimal
                break;
            case 'date':
                value = formatDateTime(a.valueDate)
                break;
            default:
                value = a.valueString
                break;
        }
        return  <Grid.Row key={a.code}><Grid.Column width={5}>{a.name}:</Grid.Column><Grid.Column width={7} className="attr-value">{value}</Grid.Column></Grid.Row>
    }

    getEditButton() {
        const {intl, history, asset} = this.props
        if (userHasActivity(this.props.userProfile, ACTIVITY_TYPES.FLEETS_WRITE)) {
            return <Button content={intl.formatMessage({id: 'link.edit.asset'})} type="secondary"
                           onClick={() => history.push(Routes.ASSETS_ADMIN + "/" + asset.details.id)}/>
        }
        return null
    }

    render() {
        const {intl, history, asset, userProfile} = this.props

        if (asset.error) {
            return <ErrorTitle title={"asset.detail.error."+asset.error} />
        }

        if (!asset.details) {
            return null
        }

        let breadcrumbComponent = null
        if (asset.details) {
            breadcrumbComponent = <BreadCrumb items={getBreadcrumbItemsAsset(asset.details.path, asset.details, false,
                userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ? intl.formatMessage({id: "admin.tab.only.assets"}) : null,
                userHasActivity(userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY))}/>
        }
        // Convert variants to same structure as Asset Attributes
        // to be able to render them in same ExpandableCard (variants first, after attributes)
        const variantAsAttribute = asset.details.variants.map(v => {
            return {
                valueString: v.name,
                dataType: null,
                code: v.code,
                name: intl.formatMessage({id: "assets.asset.detail.variant.type"}, {variantType: v.variantType}),
            }
        })
        const configurationSymptomAsAttribute = asset.details.configurationSymptoms.map(as => {
            return {valueString: as.state, dataType: null, code: as.name, name: as.name}
        })
        // Concat variants and asset attributes to one array for randering in one expandable card
        configurationSymptomAsAttribute.forEach(asattr => {
            variantAsAttribute.push(asattr)
        })
        // Concat variants and asset attributes to one array for rendering in one expandable card
        asset.details.attributes.forEach(attr => {
            variantAsAttribute.push(attr)
        })

        const varAndAttrToBeRender = this.getAttributesComponents(variantAsAttribute)

        const chartName = userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) && asset.details.variants.length > 0 ?
            "chart-hda"
            :
            "chart"

        return (
            <div id="asset-detail">
                {breadcrumbComponent}
                <Loader loading={this.props.asset.loading}/>
                <Grid className="asset-header">
                    <Grid.Row>
                        {
                            userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) && asset.details.variants.length > 0 ?
                                <Grid.Column width={2} sWidth={12}>
                                    <div>
                                        <img alt="engine" className="engine-picture"
                                             src={asset.details.variants[0].ldiName.includes('HTF7K') ? engineHTF7K : engineTFE731}/>
                                        <FormattedHTMLMessage
                                            id={asset.details.variants[0].ldiName.includes("HTF7K") ? "HTF7K" : "TFE731"}/>
                                    </div>
                                </Grid.Column>
                                :
                                null
                        }
                        <Grid.Column width={userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) && asset.details.variants.length > 0 ? 2 : 4} sWidth={12} className="asset-serial-column">
                            <h2 title={asset.details.name}>{asset.details.name}</h2>
                            <div className={chartName}>
                                <AssetChart asset={this.props.asset.details} height={220}/>
                            </div>
                        </Grid.Column>
                        <Grid.Column width={6} sWidth={12} className="asset-attributes-column">
                            {varAndAttrToBeRender}
                        </Grid.Column>
                        <Grid.Column width={2} mWidth={12}>
                            <div className="right button-column">
                                {userHasActivity(this.props.userProfile, ACTIVITY_TYPES.ASSIGNED_ISSUES_WRITE) ?
                                    <Button className="mobile-max-width-button asset-create-fault-button" content={intl.formatMessage({id: 'page.faultNew'})}
                                            onClick={() => history.push(Routes.FAULT_NEW + '?assetId=' + this.props.asset.details.id)}/>
                                    :
                                    ''
                                }
                                {this.getEditButton()}
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <FaultsList assetId={this.props.asset.details.id} />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userProfile: state.security.userProfile,
        asset: state.asset,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        AssetActions: bindActionCreators(AssetActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Asset)))